import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './VisualizarDadosViagem.css';
import { buscarDadosPontoById } from '../servicos/listagemServico';
import Cookies from 'js-cookie';

import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet-routing-machine';

import Routing from '../components/Routing';


function VisualizarDadosViagem() {

  const { id } = useParams();
  const navigate = useNavigate();

  const [ponto, setPonto] = useState(null);
  const [objServicoSolicitado, setObjServicoSolicitado] = useState(null);
  const [pilotoDisponivelMaisProximo, setPilotoDisponivelMaisProximo] = useState(null);

  const [loading, setLoading] = useState(true);

  const cookies = Cookies.get();
  const dadosCookies = cookies.dadosCookies ? JSON.parse(cookies.dadosCookies) : null;

  const [mensagemErro, setMensagemErro] = useState('');


  const BASE_URL =
    window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
      ? 'http://127.0.0.1:8000'
      : 'https://mercadinhointeligente.com.br';

  const [posicaoUsuario, setPosicaoUsuario] = useState(null);

  const iconeMoto = new L.Icon({
    iconUrl: '/imagens/icones/moto-verde-esportiva.png',
    iconSize: [65, 65],
  });

  const iconeUsuario = new L.Icon({
    iconUrl: '/imagens/icones/boneco1.png',
    iconSize: [65, 65],
  });

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const coords = [pos.coords.latitude, pos.coords.longitude];
        setPosicaoUsuario(coords);
      },
      (err) => {
        console.error('Erro ao obter localização:', err);
      }
    );
  }, []);



  console.log('=================');
  console.log('Entrou em VisualizarDadosViagem...');
  console.log('id do ponto: ' + id);

  console.log('dadosCookies: ');
  console.log(dadosCookies);



  useEffect(() => {

    console.log('Entrou no useEffect do VisualizarDadosViagem.js...');

    const carregarDados = async () => {
      try {
        console.log('Preparando para buscar os dados do ponto e do piloto próximo...');

        const dados = await buscarDadosPontoById(id, dadosCookies);
        const servicoSelecionado = dados.obj_servico_solicitado.nome;

        console.log('verificando se obteve sucesso....');
        console.log('verificando quantidade de pilotos....');
        console.log(dados.quantidadePilotosProximos);

        if (dados.quantidadePilotosProximos === 0) {

          console.log(' !!! não obteve sucesso !!!');

          alert('Nenhum piloto disponível neste Ponto, para o Serviço de ' + servicoSelecionado);

          navigate(-1);


          // setMensagemErro(dados.message || 'Erro ao localizar piloto');
          // setTimeout(() => {
          //   // navigate('/mapa');
          //   navigate(-1);

          // }, 2000); // espera 2 segundos para redirecionar
          return;
        } else {
          console.log('ok, obteve sucesso!');
        }       

        console.log('Dados recebidos em VisualizarDadosViagem.js...');
        console.log(dados);

        setPonto(dados.dados_ponto_mototaxi);
        setPilotoDisponivelMaisProximo(dados.piloto_disponivel_mais_proximo);
        setObjServicoSolicitado(dados.obj_servico_solicitado);

      } catch (erro) {
        console.error('Erro ao buscar dados do ponto:', erro);
        setPonto(null);
      } finally {
        setLoading(false);
      }
    };

    carregarDados();

  }, [id]);

  // if (loading) return <p className="text-white p-4">Carregando...</p>;
  // if (!ponto) return <p className="text-white p-4">Ponto não encontrado</p>;

  if (loading || !posicaoUsuario) return <p className="text-white p-4">Carregando...</p>;
  if (!ponto) return <p className="text-white p-4">Ponto não encontrado</p>;


  return (
    <div className="visualizar-container d-flex flex-column align-items-center">

      <div style={{ height: '400px', width: '100%', maxWidth: '500px', marginBottom: '1rem' }}>
        <MapContainer center={posicaoUsuario} zoom={16} style={{ height: '100%', width: '100%' }}>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="© OpenStreetMap contributors"
          />

          {/* Usuário */}
          <Marker position={posicaoUsuario} icon={iconeUsuario}>
            <Popup>Você está aqui</Popup>
          </Marker>

          {/* Piloto mais próximo */}
          {pilotoDisponivelMaisProximo && (
            <Marker
              position={[
                pilotoDisponivelMaisProximo.latitude,
                pilotoDisponivelMaisProximo.longitude,
              ]}
              icon={iconeMoto}
            >

            <Popup>
              <div style={{ textAlign: 'center' }}>
                <strong>{pilotoDisponivelMaisProximo.name}</strong><br />
                📞 {pilotoDisponivelMaisProximo.numero_celular_com_ddd}<br />
                <strong>Email:</strong> {pilotoDisponivelMaisProximo.email}<br />
                <a
                  href={`https://wa.me/55${pilotoDisponivelMaisProximo.numero_celular_com_ddd.replace(/\D/g, '')}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '8px',
                    textDecoration: 'none',
                    color: '#25D366',
                    marginTop: '5px',
                    fontWeight: 'bold'
                  }}
                >
                  <i className="fab fa-whatsapp" style={{ fontSize: '20px' }}></i>
                  Conversar no WhatsApp
                </a>
              </div>
            </Popup>


            </Marker>
          )}

          {/* Traçar a rota */}
          {pilotoDisponivelMaisProximo && (
            <Routing
              origem={posicaoUsuario}
              destino={[
                pilotoDisponivelMaisProximo.latitude,
                pilotoDisponivelMaisProximo.longitude,
              ]}
            />
          )}



        </MapContainer>
      </div>

      {/* Card 1 - Dados do ponto */}
      <div className="card border-0 shadow-lg mb-4 w-100" style={{ maxWidth: '500px', borderRadius: '1rem' }}>

      <div className="card-body">

        <div className="row align-items-center text-center text-md-start">

          {/* Edifício do ponto */}
          <div className="col-12 col-md-4 mb-2 mb-md-0 d-flex align-items-center justify-content-center justify-content-md-start">
          <i className="bi bi-building text-secondary me-2" style={{ fontSize: '1.8rem' }}></i>
            <span className="fw-semibold">{ponto.user.name}</span>
          </div>

          {/* Serviço solicitado */}
          <div className="col-12 col-md-5 mb-2 mb-md-0 d-flex align-items-center justify-content-center justify-content-md-start">
            <i className="bi bi-briefcase-fill text-secondary me-2"></i>
            <span className="fw-medium">
              Serviço: <strong>{objServicoSolicitado.nome}</strong>
            </span>
          </div>

          {/* Botão voltar */}
          <div className="col-12 col-md-3 d-flex justify-content-center justify-content-md-end">
            <button
              onClick={() => navigate(-1)}
              className="btn btn-outline-primary"
            >
              ← Voltar
            </button>
          </div>

        </div>
      </div>
        

      </div>



    </div>
  );
}

export default VisualizarDadosViagem;
